import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HowWeInvestRoutingModule } from './how-we-invest-routing.module';
import { StaticPageFooterModule } from 'src/app/shared/static-page-footer/static-page-footer.module';
import { HowWeInvestComponent } from 'src/app/pages/how-we-invest/how-we-invest.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    HowWeInvestComponent,
  ],
  imports: [
    CommonModule,
    HowWeInvestRoutingModule,
    StaticPageFooterModule,
    HtmlFormatPipeModule,
    TranslateModule,
    TooltipButtonModule,
    RouterModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    HowWeInvestComponent,
  ]
})
export class HowWeInvestModule { }
